/**
 * Marketing popup — session dismiss + delayed open (VN commerce overlay).
 */
(function () {
  const STORAGE_KEY = 'pi_popup_dismissed';
  const el = document.querySelector('[data-pi-popup]');
  if (!el) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function open() {
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('input, button, [href]');
    focusable?.focus();
  }

  function close() {
    el.hidden = true;
    document.body.style.overflow = '';
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (_) {}
  }

  el.querySelectorAll('[data-pi-popup-close]').forEach((node) => {
    node.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !el.hidden) close();
  });

  const form = el.querySelector('[data-pi-popup-form]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      close();
    });
  }

  const copyBtn = el.querySelector('[data-pi-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const code = el.querySelector('[data-pi-popup-code]')?.textContent?.trim();
      if (code && navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          copyBtn.textContent = 'Copied';
          setTimeout(() => {
            copyBtn.textContent = 'Copy code';
          }, 2000);
        });
      }
      close();
    });
  }

  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
  } catch (_) {}

  const delay = reduced ? 0 : 4200;
  setTimeout(open, delay);
})();
